module.exports = __webpack_public_path__ + "img/solution-finance-advantage2.321d67e7.svg";